import { useState, useCallback } from 'react';
import { ToastProps, ToastType } from '../components/ui/Toast';

let idCounter = 0;

export const useNotifications = () => {
  const [toasts, setToasts] = useState<ToastProps[]>([]);

  const showNotification = useCallback((
    type: ToastType,
    title: string,
    message?: string,
    duration?: number
  ) => {
    const id = `toast-${++idCounter}`;
    const toast: ToastProps = {
      id,
      type,
      title,
      message,
      duration,
      onClose: (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }
    };

    setToasts((prev) => [...prev, toast]);
    return id;
  }, []);

  const removeNotification = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showSuccess = useCallback(
    (title: string, message?: string, duration?: number) =>
      showNotification('success', title, message, duration),
    [showNotification]
  );

  const showError = useCallback(
    (title: string, message?: string, duration?: number) =>
      showNotification('error', title, message, duration),
    [showNotification]
  );

  const showWarning = useCallback(
    (title: string, message?: string, duration?: number) =>
      showNotification('warning', title, message, duration),
    [showNotification]
  );

  const showInfo = useCallback(
    (title: string, message?: string, duration?: number) =>
      showNotification('info', title, message, duration),
    [showNotification]
  );

  return {
    toasts,
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    removeNotification
  };
};
